import type {
  InfoCardGridLayout,
  InfoCardGridModuleProps,
  InfoCardGridTone,
} from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

const layoutClass: Record<InfoCardGridLayout, string> = {
  GRID: "grid",
  COLUMNS: "columns",
  RULE_LIST: "rule-list",
  LEFT: "left",
  CENTERED: "centered",
};

const toneClass: Record<InfoCardGridTone, string> = {
  LIGHT: "light",
  COCOA: "cocoa",
  SEAFOAM: "seafoam",
};

export function InfoCardGridModule({
  eyebrow,
  heading,
  body,
  layout = "GRID",
  tone = "LIGHT",
  items,
}: InfoCardGridModuleProps) {
  const normalizedLayout = layoutClass[layout] ? layout : "GRID";
  const normalizedTone = toneClass[tone] ? tone : "LIGHT";
  const isDark = normalizedTone === "COCOA";

  return (
    <section
      className={[
        "cms-section",
        "cms-info-card-grid",
        `cms-info-card-grid--layout-${layoutClass[normalizedLayout]}`,
        `cms-info-card-grid--tone-${toneClass[normalizedTone]}`,
        isDark ? "cms-tone-dark" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      data-cms-module="info-card-grid"
    >
      <div className="cms-wrap">
        <div className="cms-info-card-grid__intro">
          <div className="cms-eyebrow-row">
            <span className="cms-eyebrow">
              {renderTextWithLineBreaks(eyebrow || "Highlights")}
            </span>
          </div>
          {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
          {body ? (
            <p className="cms-info-card-grid__lead">
              {renderTextWithLineBreaks(body)}
            </p>
          ) : null}
        </div>
        <div className="cms-info-card-grid__grid" data-card-count={items.length}>
          {items.map((item, index) => (
            <article
              className="cms-info-card-grid__item"
              key={item.title || index}
            >
              {item.title ? <h3>{renderTextWithLineBreaks(item.title)}</h3> : null}
              {item.body ? <p>{renderTextWithLineBreaks(item.body)}</p> : null}
              {item.ctaLabel && item.ctaUrl ? (
                <a href={item.ctaUrl} rel="noopener noreferrer">
                  {item.ctaLabel}
                </a>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
